@if (state.availableFilters) {
  <div class="flex items-center gap-2 overflow-x-auto md:flex-wrap md:gap-3">
    <dojo-question-bank-sort *ifSmallLayout />

    <dojo-multiple-filters-button
      *ifSmallLayout
      [buttonLabel]="'examdojo.question_bank.all_filters' | transloco"
      [titleLabel]="'examdojo.question_bank.all_filters' | transloco"
      (clearAll)="clearAllFilters()"
    >
      @if (state.availableFilters.type) {
        <ng-template dojoFilterSection="type" [label]="'examdojo.type' | transloco" [count]="state.filterCounts.type">
          <ng-container *ngTemplateOutlet="typeFilterContent" />
        </ng-template>
      }
      @if (state.availableFilters.difficulty) {
        <ng-template
          dojoFilterSection="difficulty"
          [label]="'examdojo.difficulty_label' | transloco"
          [count]="state.filterCounts.difficulty"
        >
          <ng-container *ngTemplateOutlet="difficultyFilterContent" />
        </ng-template>
      }
      @if (state.availableFilters.maxPoints) {
        <ng-template
          dojoFilterSection="maxMarks"
          [label]="'examdojo.max_marks' | transloco"
          [count]="state.filterCounts.maxMarks"
        >
          <ng-container *ngTemplateOutlet="marksFilterContent" />
        </ng-template>
      }
      @if (state.availableFilters.tags) {
        <ng-template
          dojoFilterSection="tags"
          [label]="'examdojo.tags.tags_label' | transloco"
          [count]="state.filterCounts.tags"
        >
          <ng-container *ngTemplateOutlet="tagsFilterContent" />
        </ng-template>
      }
      <ng-template
        dojoFilterSection="topics"
        [label]="'examdojo.topics_tree.topics' | transloco"
        [count]="state.topicsCount"
      >
        <ng-container *ngTemplateOutlet="topicsFilterContent" />
      </ng-template>
    </dojo-multiple-filters-button>

    <dojo-filter-button
      *ifSmallLayout
      [defaultLabel]="'examdojo.topics_tree.topics' | transloco"
      [count]="state.topicsCount"
      [alwaysShowCount]="true"
      (clear)="clearTopics()"
    >
      <ng-template #filterContent>
        <ng-container *ngTemplateOutlet="topicsFilterContent" />
      </ng-template>
    </dojo-filter-button>

    @if (state.availableFilters.difficulty) {
      <dojo-filter-button
        [defaultLabel]="'examdojo.difficulty_label' | transloco"
        [selectedLabel]="state.selectedDifficultyLabel"
        [count]="state.filterCounts.difficulty"
        (clear)="resetFilters(['difficulties'])"
      >
        <ng-template #filterContent>
          <ng-container *ngTemplateOutlet="difficultyFilterContent" />
        </ng-template>
      </dojo-filter-button>
    }

    @if (state.availableFilters.type) {
      <dojo-filter-button
        [defaultLabel]="'examdojo.type' | transloco"
        [selectedLabel]="state.selectedTypeLabel"
        [count]="state.filterCounts.type"
        (clear)="resetFilters(['types'])"
        [customMatMenuClass]="'types-filter-menu filters-bank-mat-menu'"
      >
        <ng-template #filterContent>
          <ng-container *ngTemplateOutlet="typeFilterContent" />
        </ng-template>
      </dojo-filter-button>
    }

    @if (state.availableFilters.maxPoints) {
      <dojo-filter-button
        [defaultLabel]="'examdojo.max_marks' | transloco"
        [selectedLabel]="state.selectedMaxMarksLabel"
        [count]="state.filterCounts.maxMarks"
        [clearLabelKey]="'examdojo.reset'"
        (clear)="resetFilters(['minPoints', 'maxPoints'])"
      >
        <ng-template #filterContent>
          <ng-container *ngTemplateOutlet="marksFilterContent" />
        </ng-template>
      </dojo-filter-button>
    }

    @if (state.availableFilters.tags) {
      <dojo-filter-button
        [defaultLabel]="'examdojo.tags.tags_label' | transloco"
        [selectedLabel]="state.selectedTagLabel"
        [count]="state.filterCounts.tags"
        (clear)="resetFilters(['tags'])"
      >
        <ng-template #filterContent>
          <ng-container *ngTemplateOutlet="tagsFilterContent" />
        </ng-template>
      </dojo-filter-button>
    }

    @if (state.hasActiveFilters) {
      <button type="button" class="text-secondary whitespace-nowrap text-sm font-medium" (click)="clearAllFilters()">
        {{ 'examdojo.clear_all' | transloco }}
      </button>
    }
  </div>
}

<ng-template #difficultyFilterContent>
  <mat-selection-list
    [formControl]="form.controls.difficulties"
    class="custom-selection-list-checkbox-appearance bank-filters"
  >
    @for (option of state.difficultyOptions; track option.value) {
      <mat-list-option [togglePosition]="'before'" [value]="option.value">
        <span class="text-primary text-md md:text-sm">{{ option.label }}</span>
      </mat-list-option>
    }
  </mat-selection-list>
</ng-template>

<ng-template #typeFilterContent>
  <mat-selection-list
    [formControl]="form.controls.types"
    class="custom-selection-list-checkbox-appearance bank-filters"
  >
    @for (option of state.typeOptions; track option.value) {
      <mat-list-option [togglePosition]="'before'" [value]="option.value">
        <span class="text-primary text-md md:text-sm">{{ option.label }}</span>
      </mat-list-option>
    }
  </mat-selection-list>
</ng-template>

<ng-template #marksFilterContent>
  <div class="flex flex-col px-1.5 pt-8">
    <div class="flex items-end justify-center px-3 pb-2">
      <mat-slider
        discrete
        [min]="state.marksRange.min"
        [step]="1"
        [max]="state.marksRange.max"
        class="slider-always-show-tooltips w-full"
      >
        <input
          #minPointsSlider
          matSliderStartThumb
          [value]="form.controls.minPoints.value"
          (change)="form.controls.minPoints.setValue(+minPointsSlider.value)"
        />
        <input
          #maxPointsSlider
          matSliderEndThumb
          [value]="form.controls.maxPoints.value"
          (change)="form.controls.maxPoints.setValue(+maxPointsSlider.value)"
        />
      </mat-slider>
    </div>
  </div>
</ng-template>

<ng-template #tagsFilterContent>
  <dojo-tag-selection-list
    [control]="form.controls.tags"
    [searchPlaceholder]="'examdojo.tags.search_placeholder' | transloco"
  />
</ng-template>

<ng-template #topicsFilterContent>
  <dojo-question-bank-topics-explorer class="mobile-topics-explorer" />
</ng-template>
